import { LineItem } from 'types';

interface LineItemsForPageProps {
  currentPage: number;
  lineItems: LineItem[];
  pageSize: number;
}

export const DEFAULT_PAGE_SIZE = 25;
export const PAGE_SIZE_OPTIONS = [DEFAULT_PAGE_SIZE, 50, 100];

/**
 * Shared pagination utility used by both buyer and supplier line item tables
 * Extracts line items for the current page based on pagination parameters
 */
export const getLineItemsForPage = ({ currentPage, lineItems, pageSize }: LineItemsForPageProps): LineItem[] => {
  const prevPage = (currentPage - 1) <= 0 ? 0 : (currentPage - 1);
  const currentPageAdjusted = currentPage < 1 ? 1 : currentPage;

  const startIndex = prevPage * pageSize;
  const endIndex = currentPageAdjusted * pageSize;

  return lineItems.slice(startIndex, endIndex);
};
